export const NotificationTypes = {
  PresentationStarted: 'PresentationStarted',
  PresentationEnded: 'PresentationEnded',
  PresentationIsComing: 'PresentationIsComing',
}
